import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2rem',
  },
  dialogActions: {
    justifyContent: 'center',
    marginTop: '2rem',
  },
  dialogTitle: {
    textAlign: 'center',
  },
  dialogContent: {
    textAlign: 'center',
  },
  dialogImage: {
    width: '4rem',
  },
  insertButton: {
    color: '#ffffff',
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
}));

type ConfirmationPopupProps = {
  open: boolean;
  onClose: () => void;
  message: string;
};

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({ open, onClose, message }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
      <DialogActions className={classes.dialogActions}>
        <img src="./images/success.png" alt="Complete" className={classes.dialogImage} />
      </DialogActions>
      <DialogTitle className={classes.dialogTitle}>Complete!</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" className={classes.insertButton}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
